import styled from "styled-components";

interface IUserStatusCongratulationsIconBackgroundProps {
    background: string;
}

export const UserStatusCongratulationsIconBackgroundStyled = styled.div<IUserStatusCongratulationsIconBackgroundProps>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${({ background }) => !!background && `background: ${background};`}
    opacity: 0.13;
`;

export const UserStatusCongratulationsIconBackgroundMobileStyled = styled(UserStatusCongratulationsIconBackgroundStyled)`
    width: 282px;
    height: 260px;
    border-radius: 282px;
    filter: blur(84px);
`;

export const UserStatusCongratulationsIconBackgroundDesktopStyled = styled(UserStatusCongratulationsIconBackgroundStyled)`
    width: 301px;
    height: 308px;
    border-radius: 308px;
    filter: blur(84px);
`;
